import { useQuery } from '@tanstack/react-query';
import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { zonalManagersQueryOptions } from '@/features/users/api/users.api';
import { useGeoCascade } from '@/hooks/useGeoCascade';
import { getFilterPanelProps, type UrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import {
  getDateFromToFilterFields,
  getGeoFilterFields,
  getZonalManagerFilterField,
} from '@/utils/filterFields';
import { FILTER_KEYS, parseNumberFilter } from '@/utils/filters';
import { promoItemTypesQueryOptions } from '../api/promotion.api';
import { ACTIVE_ROWS_LOOKUP_PARAMS } from '../constants/promotion.constants';
import {
  getItemCodeFilterField,
  getPromoItemTypeFilterField,
} from '../utils/promotionFilterFields';

interface PromoAdjustmentFilterPanelProps {
  filters: UrlSyncedFilters;
}

export function PromoAdjustmentFilterPanel({ filters }: PromoAdjustmentFilterPanelProps) {
  const { filterValues } = filters;

  const { data: zonalManagers } = useQuery(zonalManagersQueryOptions());
  const { data: itemTypes } = useQuery(promoItemTypesQueryOptions(ACTIVE_ROWS_LOOKUP_PARAMS));
  const geoOptions = useGeoCascade({
    divisionId: parseNumberFilter(filterValues[FILTER_KEYS.divisionId]),
    districtId: parseNumberFilter(filterValues[FILTER_KEYS.districtId]),
  });

  return (
    <AdvancedFilterPanel
      fields={[
        ...getDateFromToFilterFields(),
        getZonalManagerFilterField(zonalManagers),
        ...getGeoFilterFields(filterValues, geoOptions),
        getPromoItemTypeFilterField(itemTypes?.data),
        getItemCodeFilterField(),
      ]}
      {...getFilterPanelProps(filters)}
    />
  );
}
